import { AccountDormantByStatuses } from './AccountDormantByStatuses';

export const AccountDormantByStatusDescriptions:Map<AccountDormantByStatuses, string> = new Map([
  [AccountDormantByStatuses.DORMANT_DATE, 'Dormant Date'],
  [AccountDormantByStatuses.STATUS_CODE, 'Status Code'],
  [AccountDormantByStatuses.STATUS_CODE_AND_DORMANT_DATE, 'Dormant Date AND Status Code'],
  [AccountDormantByStatuses.STATUS_CODE_OR_DORMANT_DATE, 'Dormant Date OR Status Code'],
]);

export default AccountDormantByStatusDescriptions;
